module.exports = __webpack_public_path__ + "static/media/wordmark_white.32c9f888.svg";